import { PatientGroup, PatientGroupQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { translationKeys } from '../../../translations';

type CustomPatientGroupsUpdateFormLoaderRenderProps = {
   patientGroup: PatientGroup;
};

type CustomPatientGroupsUpdateFormLoaderProps = {
   children: (renderProps: CustomPatientGroupsUpdateFormLoaderRenderProps) => JSX.Element;
   patientGroupId: number;
};

export const CustomPatientGroupsUpdateFormLoader = (props: CustomPatientGroupsUpdateFormLoaderProps): JSX.Element => {
   const { data: patientGroup, error: patientGroupError, loading: patientGroupLoading } = useCqrsGet<PatientGroup>(
      () => {
         const query = new PatientGroupQuery();
         query.id = Slot.of(props.patientGroupId);
         return query;
      }
   );

   if (patientGroupLoading) {
      return <LoaderSpinner />;
   }

   if (patientGroupError) {
      return (
         <Message
            testId={'customPatientGroupFetchError'}
            type={MessageType.NEGATIVE}
            label={translationKeys.customPatientGroupFetchError}
            displayIndicator
         />
      );
   }

   return props.children({ patientGroup: patientGroup });
};
